import { Component, inject, input } from '@angular/core';

import { OfferItem, StatusChangeType } from '@core/offers-types';
import { JobsAnalytics } from '@recruitee/offers-legacy';
import { JobActionsDataService, JobActionsFacade } from '@recruitee/offers-logic';
import { JobActionsDropdownType } from '@recruitee/offers-types';
import { JobActionsDropdownComponent } from '@recruitee/offers-ui';

@Component({
  selector: 'rt-job-actions-dropdown-container',
  template: `
    <rt-job-actions-dropdown
      [job]="job()"
      [type]="type()"
      [canManageJobs]="canManageJobs()"
      (action)="action($event)"
      (trackPreview)="trackPreview()"
    />
  `,
  imports: [JobActionsDropdownComponent],
})
export class JobActionsDropdownContainerComponent {
  private readonly actionsFacade = inject(JobActionsFacade);
  private readonly jobActionsDataService = inject(JobActionsDataService);
  private readonly jobsAnalytics = inject(JobsAnalytics);

  public job = input.required<OfferItem>();
  public type = input<JobActionsDropdownType>(JobActionsDropdownType.List);

  protected canManageJobs = this.jobActionsDataService.canManageJobs;

  public action(name: StatusChangeType): void {
    switch (name) {
      case StatusChangeType.Duplicate:
        this.actionsFacade.duplicate(this.job());
        break;
      case StatusChangeType.Archive:
        this.actionsFacade.archive(this.job());
        break;
      case StatusChangeType.Unarchive:
        this.actionsFacade.retrieve(this.job());
        break;
      case StatusChangeType.Delete:
        this.actionsFacade.delete(this.job());
        break;
      default:
        break;
    }
    return;
  }

  public trackPreview(): void {
    this.jobsAnalytics.trackViewJob();
  }
}
